// Port of api/fuel/app/classes/filter/search/games/filters/query/comment/count.php
import { rangeActive } from 'offline/filter/core/search/unit'
export default {
	name: 'comment.count',
	priority: 81,
	require: function(config, filter) { return rangeActive(filter.comments, 0, 50) },
	run: function(config, filter, data, query) {
		if (filter.comments.from > 0) query.having('COUNT(DISTINCT(m.comment_id))', '>=', filter.comments.from)
		if (filter.comments.to < 50) query.having('COUNT(DISTINCT(m.comment_id))', '<=', filter.comments.to)
	}
}
